import type { ReviewCycle } from './types';

/**
 * Does this cycle have a working file someone could open and edit?
 *
 * A web-page cycle is a captured snapshot of a page that lives in HubSpot —
 * there is nothing in SharePoint to edit — and the same goes for a bare image
 * or video child (Fredrik, 2026-08-21).
 *
 * A PDF counts only when an editable companion (docx/pptx) is attached: that
 * companion is what anyone would actually edit, and it is also the only case
 * where the system can apply a proposed replacement (see DocumentViewer's
 * canPropose, which uses the same rule).
 */
const DIRECTLY_EDITABLE = ['docx', 'pptx', 'xlsx'];

export function hasEditableWorkingFile(cycle: Pick<ReviewCycle, 'contentType' | 'contentItem'> | null | undefined): boolean {
  if (!cycle) return false;
  const type = (cycle.contentType || '').toLowerCase();
  if (DIRECTLY_EDITABLE.includes(type)) return true;
  if (type === 'pdf') {
    const companion = ((cycle.contentItem as any)?.sourceFileName || '').toLowerCase();
    return /\.(docx|pptx|xlsx)$/.test(companion);
  }
  return false;
}
